import React, { useState } from 'react';
import { Row, Col, Card, Badge, ProgressBar, Table } from 'react-bootstrap';
import * as FaIcons from 'react-icons/fa';
import ErroresTarifariosModal from '../../../cierre/ErroresTarifariosModal';

const AnalisisDetallado = ({ resumenDiario, formatearMonto, formatearPorcentaje, user, permisos, searchCombinationsFromErrors }) => {
  // Estado para el modal de errores
  const [modalState, setModalState] = useState({
    show: false,
    errorType: null,
    errorData: null
  });

  // Función para abrir el modal
  const handleOpenModal = (errorType) => {
    const errorData = resumenDiario.errores_tarifario?.[errorType] || [];
    setModalState({
      show: true,
      errorType,
      errorData
    });
  };

  // Función para cerrar el modal
  const handleCloseModal = () => {
    setModalState({
      show: false,
      errorType: null,
      errorData: null
    });
  };
  const obtenerColorEmpresa = (sigla) => {
    const colores = {
      'MER': 'primary',
      'CER': 'success', 
      'SPR': 'warning',
      'LOG': 'info',
      'DIS': 'danger'
    };
    return colores[sigla] || 'dark';
  };

  // Función para obtener color según el estado de entrega
  const obtenerColorEstado = (estado, cantidad, total) => {
    const porcentaje = (cantidad / total) * 100;
    
    if (estado === 'Entrega exitosa') return 'success';
    if (estado.toLowerCase().includes('rechaza') || estado.toLowerCase().includes('problema')) return 'danger';
    if (estado.toLowerCase().includes('ruta') || estado.toLowerCase().includes('entregado')) return 'primary';
    if (estado.toLowerCase().includes('moradores') || estado.toLowerCase().includes('direccion')) return 'warning';
    if (porcentaje >= 10) return 'info';
    if (porcentaje >= 5) return 'secondary';
    return 'light';
  };

  if (!resumenDiario) {
    return (
      <div className="text-center p-5">
        <FaIcons.FaChartLine style={{ fontSize: '3rem', color: '#dee2e6', marginBottom: '16px' }} />
        <h6 style={{ color: '#6c757d' }}>No hay datos disponibles para el análisis</h6>
      </div>
    );
  }

  // Calcular métricas adicionales
  const calcularMetricas = () => {
    const { detalle_conductores, resumen } = resumenDiario;
    
    if (!detalle_conductores) return {};

    const conductoresOrdenados = [...detalle_conductores]
      .sort((a, b) => b.total_guias - a.total_guias);

    const mejorNS = conductoresOrdenados
      .map(c => ({
        ...c,
        ns_promedio: c.rutas.reduce((sum, r) => sum + (r.ns || 0), 0) / c.rutas.length
      }))
      .sort((a, b) => b.ns_promedio - a.ns_promedio);

    return {
      conductoresOrdenados,
      mejorNS: mejorNS.slice(0, 5),
      peorNS: mejorNS.slice(-5).reverse()
    };
  };

  const metricas = calcularMetricas();

  return (
    <>
      {/* Header */}
      <Row className="mb-4">
        <Col xs={12}>
          <h5 className="mb-3">
            <FaIcons.FaChartLine className="me-2" style={{ color: '#1976d2' }} />
            Análisis Detallado y Métricas Avanzadas
          </h5>
        </Col>
      </Row>

      {/* Análisis de Errores de Tarifario */}
      {resumenDiario.errores_tarifario && (
        <Row className="mb-4">
          <Col xs={12} md={4}>
            <Card className="border-danger h-100" style={{ cursor: 'pointer' }} onClick={() => handleOpenModal('egreso')}>
              <Card.Header className="bg-danger text-white">
                <h6 className="mb-0">
                  <FaIcons.FaExclamationTriangle className="me-2" />
                  Errores de Tarifario - Egreso
                </h6>
              </Card.Header>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="text-danger mb-0">{resumenDiario.errores_tarifario.egreso?.length || 0}</h4>
                  <small className="text-muted">errores detectados</small>
                </div>
                {resumenDiario.errores_tarifario.egreso?.length > 0 && (
                  <div className="mt-3">
                    <small className="text-muted d-block mb-2">Últimos errores:</small>
                    {resumenDiario.errores_tarifario.egreso.slice(0, 3).map((error, index) => (
                      <div key={index} className="bg-light p-2 rounded mb-2">
                        <small>
                          <strong>Guía:</strong> {error.guia_id} - 
                          <strong> Ruta:</strong> {error.ruta_id}
                        </small>
                      </div>
                    ))}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card className="border-warning h-100" style={{ cursor: 'pointer' }} onClick={() => handleOpenModal('ingreso')}>
              <Card.Header className="bg-warning text-white">
                <h6 className="mb-0">
                  <FaIcons.FaExclamationTriangle className="me-2" />
                  Errores de Tarifario - Ingreso
                </h6>
              </Card.Header>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="text-warning mb-0">{resumenDiario.errores_tarifario.ingreso?.length || 0}</h4>
                  <small className="text-muted">errores detectados</small>
                </div>
                {resumenDiario.errores_tarifario.ingreso?.length > 0 && (
                  <div className="mt-3">
                    <small className="text-muted d-block mb-2">Últimos errores:</small>
                    {resumenDiario.errores_tarifario.ingreso.slice(0, 3).map((error, index) => (
                      <div key={index} className="bg-light p-2 rounded mb-2">
                        <small>
                          <strong>Guía:</strong> {error.guia_id} - 
                          <strong> Ruta:</strong> {error.ruta_id}
                        </small>
                      </div>
                    ))}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={4}>
            <Card className="border-info h-100" style={{ cursor: 'pointer' }} onClick={() => handleOpenModal('empresa')}>
              <Card.Header className="bg-info text-white">
                <h6 className="mb-0">
                  <FaIcons.FaBuilding className="me-2" />
                  Errores de Empresa
                </h6>
              </Card.Header>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h4 className="text-info mb-0">{resumenDiario.errores_tarifario.empresa?.length || 0}</h4>
                  <small className="text-muted">errores detectados</small>
                </div>
                {resumenDiario.errores_tarifario.empresa?.length > 0 && (
                  <div className="mt-3">
                    <small className="text-muted d-block mb-2">Últimos errores:</small>
                    {resumenDiario.errores_tarifario.empresa.slice(0, 3).map((error, index) => (
                      <div key={index} className="bg-light p-2 rounded mb-2">
                        <small>
                          <strong>Empresa:</strong> {error.empresa_data?.sigla || 'N/A'} - 
                          <strong> Guía:</strong> {error.guia_id}
                        </small>
                      </div>
                    ))}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Estadísticas de Precios */}
      {resumenDiario.estadisticas_precios && (
        <Row className="mb-4">
          <Col xs={12}>
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-light border-0">
                <h6 className="mb-0">
                  <FaIcons.FaCalculator className="me-2" style={{ color: '#17a2b8' }} />
                  Estadísticas de Cálculo de Precios
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                  <Col xs={12} md={6}>
                    <h6 className="text-primary">Egresos</h6>
                    <div className="mb-3">
                      {Object.entries(resumenDiario.estadisticas_precios.egreso).map(([tipo, cantidad]) => (
                        <div key={tipo} className="d-flex justify-content-between align-items-center mb-2">
                          <small className="text-muted">{tipo.replace(/_/g, ' ').toUpperCase()}:</small>
                          <Badge bg="primary">{cantidad}</Badge>
                        </div>
                      ))}
                    </div>
                  </Col>
                  <Col xs={12} md={6}>
                    <h6 className="text-info">Ingresos</h6>
                    <div className="mb-3">
                      {Object.entries(resumenDiario.estadisticas_precios.ingreso).map(([tipo, cantidad]) => (
                        <div key={tipo} className="d-flex justify-content-between align-items-center mb-2">
                          <small className="text-muted">{tipo.replace(/_/g, ' ').toUpperCase()}:</small>
                          <Badge bg="info">{cantidad}</Badge>
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Top Conductores */}
      {metricas.conductoresOrdenados && (
        <Row className="mb-4">
          <Col xs={12} md={6}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Header className="bg-success text-white">
                <h6 className="mb-0">
                  <FaIcons.FaTrophy className="me-2" />
                  Top 5 - Mayor Volumen de Guías
                </h6>
              </Card.Header>
              <Card.Body className="p-0">
                <Table className="mb-0" size="sm">
                  <tbody>
                    {metricas.conductoresOrdenados.slice(0, 5).map((conductor, index) => (
                      <tr key={conductor.conductor.id}>
                        <td className="text-center" style={{ width: '50px' }}>
                          <Badge bg={index === 0 ? 'warning' : index === 1 ? 'secondary' : index === 2 ? 'dark' : 'light'}>
                            {index + 1}
                          </Badge>
                        </td>
                        <td>
                          <div>
                            <strong>{conductor.conductor.nombre} {conductor.conductor.apellido}</strong>
                            <br />
                            <Badge bg={obtenerColorEmpresa(conductor.empresa.sigla)} size="sm" className="fw-bold">
                              {conductor.empresa.sigla}
                            </Badge>
                          </div>
                        </td>
                        <td className="text-end">
                          <Badge bg="success">{conductor.total_guias} guías</Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={6}>
            <Card className="shadow-sm border-0 h-100">
              <Card.Header className="bg-primary text-white">
                <h6 className="mb-0">
                  <FaIcons.FaAward className="me-2" />
                  Top 5 - Mejor Nivel de Servicio
                </h6>
              </Card.Header>
              <Card.Body className="p-0">
                <Table className="mb-0" size="sm">
                  <tbody>
                    {metricas.mejorNS.map((conductor, index) => (
                      <tr key={conductor.conductor.id}>
                        <td className="text-center" style={{ width: '50px' }}>
                          <Badge bg={index === 0 ? 'warning' : index === 1 ? 'secondary' : index === 2 ? 'dark' : 'light'}>
                            {index + 1}
                          </Badge>
                        </td>
                        <td>
                          <div>
                            <strong>{conductor.conductor.nombre} {conductor.conductor.apellido}</strong>
                            <br />
                            <Badge bg={obtenerColorEmpresa(conductor.empresa.sigla)} size="sm" className="fw-bold">
                              {conductor.empresa.sigla}
                            </Badge>
                          </div>
                        </td>
                        <td className="text-end">
                          <Badge bg="primary">{formatearPorcentaje(conductor.ns_promedio)}</Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Distribución Detallada de Estados */}
      {resumenDiario.distribucion_estados && (
        <Row className="mb-4">
          <Col xs={12}>
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-light border-0">
                <h6 className="mb-0">
                  <FaIcons.FaChartBar className="me-2" style={{ color: '#6f42c1' }} />
                  Distribución Completa de Estados
                </h6>
              </Card.Header>
              <Card.Body>
                <Row>
                  {Object.entries(resumenDiario.distribucion_estados)
                    .sort(([,a], [,b]) => b - a)
                    .map(([estado, cantidad]) => {
                      const totalGuias = resumenDiario.resumen.total_guias;
                      const porcentaje = (cantidad / totalGuias) * 100;
                      
                      return (
                        <Col xs={12} md={6} lg={4} key={estado} className="mb-3">
                          <div className="border rounded p-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <small className="fw-bold text-dark">{estado}</small>
                              <Badge 
                                bg={obtenerColorEstado(estado, cantidad, totalGuias)} 
                                className="fw-bold"
                                style={{ minWidth: '50px' }}
                              >
                                {cantidad}
                              </Badge>
                            </div>
                            <ProgressBar 
                              now={porcentaje} 
                              label={`${porcentaje.toFixed(1)}%`}
                              variant={obtenerColorEstado(estado, cantidad, totalGuias)}
                              className="fw-bold"
                              style={{ height: '25px', fontSize: '14px' }}
                            />
                          </div>
                        </Col>
                      );
                    })}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Métricas de Rendimiento por Punto de Entrega */}
      {resumenDiario.resumen && (
        <Row className="mb-4">
          <Col xs={12}>
            <Card className="shadow-sm border-0">
              <Card.Header className="bg-light border-0">
                <h6 className="mb-0">
                  <FaIcons.FaMapMarkerAlt className="me-2" style={{ color: '#dc3545' }} />
                  Métricas de Puntos de Entrega
                </h6>
              </Card.Header>
              <Card.Body>
                <Row className="text-center">
                  <Col xs={12} md={3} className="mb-3">
                    <div className="p-3 bg-light rounded">
                      <h4 className="text-primary mb-1">{resumenDiario.resumen.total_puntos_entrega}</h4>
                      <small className="text-muted">Puntos Totales</small>
                    </div>
                  </Col>
                  <Col xs={12} md={3} className="mb-3">
                    <div className="p-3 bg-light rounded">
                      <h4 className="text-success mb-1">{resumenDiario.resumen.puntos_entrega_exitosos}</h4>
                      <small className="text-muted">Puntos Exitosos</small>
                    </div>
                  </Col>
                  <Col xs={12} md={3} className="mb-3">
                    <div className="p-3 bg-light rounded">
                      <h4 className="text-warning mb-1">
                        {formatearPorcentaje(resumenDiario.resumen.porcentaje_entrega_consolidado)}
                      </h4>
                      <small className="text-muted">NS Consolidado</small>
                    </div>
                  </Col>
                  <Col xs={12} md={3} className="mb-3">
                    <div className="p-3 bg-light rounded">
                      <h4 className="text-info mb-1">
                        {(resumenDiario.resumen.total_guias / resumenDiario.resumen.total_puntos_entrega).toFixed(1)}
                      </h4>
                      <small className="text-muted">Guías por Punto</small>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* Modal de errores de tarifarios */}
      <ErroresTarifariosModal
        show={modalState.show}
        onHide={handleCloseModal}
        errorType={modalState.errorType}
        errorData={modalState.errorData}
        user={user}
        permisos={permisos}
        searchCombinationsFromErrors={searchCombinationsFromErrors}
      />
    </>
  );
};

export default AnalisisDetallado;
